import Swiper from "swiper";

export default () => {
  document.querySelectorAll('.head-image').forEach((container) => {
    const slider = container.querySelector('.swiper-container');
    const images = container.querySelectorAll('.head-image__img');

    if (images.length < 2) return

    const swiper = new Swiper(slider, {
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
        waitForTransition: false,
      },
      direction: 'horizontal',
      effect: 'fade',
      slidesPerView: '1',
      speed: 1000,
      pagination: false,
    });
  });
};
